<script setup lang="ts">
import type { Video } from "~/types/media"

const {
  transcription,
  close,
  isDark = true,
} = defineProps<{
  transcription: Video["transcription"]
  close: () => void
  isDark?: boolean
}>()
</script>

<template>
  <div
    id="transcription"
    class="flex justify-start items-start border-2 gap-4 flex-col rounded-lg p-6 max-h-[60vh] font-national2 @xl:w-1/3"
    :class="{
      'border-white border-opacity-40': isDark,
    }"
  >
    <div class="flex items-start justify-between w-full gap-4">
      <span class="text-2xl font-extrabold">Transkripsjon</span>
      <UButtonNew
        aria-label="lukk transkripsjon"
        aria-controls="transcription"
        variant="quite"
        :theme="isDark ? 'white' : 'black'"
        @click="close"
      >
        <template #prepend>
          <UIcon name="close" />
        </template>
      </UButtonNew>
    </div>

    <p
      v-if="transcription.html"
      class="flex-wrap pr-6 overflow-scroll text-xl leading-10"
      v-html="transcription.html"
    />
    <p v-else class="wrap">
      Vi fant dessverre ingen transkripsjon, <br />
      <UContactCustomerService />
    </p>
  </div>
</template>
